import React from 'react'
import { i18nTranslate, trackNavigationClick } from 'src/utils'
import { Link } from 'react-router-dom'
import { pageNames } from 'src/routes/pathParams'
import { APPConfig } from 'config/appConfig'
import { getCategoryLinks } from '../deps'
import { renderLinkCheck, parseMenuCategory, convertToBoolean } from 'src/utils'

const BOLD_CATEGORIES = [
  'discover_nuskin_beauty',
  'nuskin_glow_kit',
  'discover_pharmanex_nutrition',
  'core_nutrition_kit',
  'discover_serenu_professional',
  'serenu_professional_kit',
]

class SubCategories extends React.PureComponent {
  nameSpace = 'ssr-resource'

  handleClick = (linkText, linkUrl) => {
    const fullLinkUrl = `${location?.origin || ''}${linkUrl}`
    trackNavigationClick('header_navigation', linkText, fullLinkUrl)
    this.props.handleToggle()
  }

  hardcodedCategoryLinks = {
    sustainability:
      'https://www.nuskin.com/content/globalffg/sustainability/home.html',
    socialimpact: 'https://www.nuskin.com/content/globalffg/home.html',
  }

  LinkOrA = (identifier, children, navigateTo = '', className = '') => {
    const linkObj = renderLinkCheck(navigateTo)
    const enableAdditionalCategoriesInMenu =
      APPConfig?.getAppConfig()?.enableAdditionalCategoriesInMenu === 'true'
    const linkUrl =
      linkObj?.link || this.hardcodedCategoryLinks[identifier] || ''
    const linkText = children?.props?.children || ''
    // Check if identifier should be bold
    let shouldBeBold = false
    if (enableAdditionalCategoriesInMenu) {
      shouldBeBold = BOLD_CATEGORIES.includes(identifier)
    }
    const boldClass = shouldBeBold ? 'font-weight-bold' : ''
    const combinedClassName = `${className} ${boldClass}`.trim()
    const href = linkObj?.link || this.hardcodedCategoryLinks[identifier]
    if (this.hardcodedCategoryLinks[identifier] || linkObj?.isThirdPartyPage) {
      return (
        <a
          className={combinedClassName}
          href={href}
          target={(href?.includes("/content") || href?.includes("/site")) ? "_self" : "_blank"}
          rel="noopener noreferrer">
          {children}
        </a>
      )
    }

    return (
      <Link
        className={combinedClassName}
        onClick={() => this.handleClick(identifier, linkUrl, linkText)}
        to={identifier ? navigateTo : '#'}>
        {children}
      </Link>
    )
  }

  renderSubCategoryList = subCategories => {
    const identifier = subCategories?.identifier || ''
    const navigateTo = getCategoryLinks(subCategories, false)
    const subCategoryName = parseMenuCategory(
      subCategories?.properties?.name || ''
    )
    return (
      <div
        className="sub-item"
        key={`${identifier}_${Math.floor(Math.random() * 100)}`}>
        {this.LinkOrA(
          identifier,
          <span data-testid="qa-category">{subCategoryName}</span>,
          navigateTo
        )}
      </div>
    )
  }

  render() {
    const { subCategory } = this.props
    const { properties, subCategories = [] } = subCategory
    let {
      name: subCategoryName = '',
      meta_description = i18nTranslate(
        'menu.description',
        'Description not available for this product/category.',
        { nameSpace: this.nameSpace }
      ),
      imageURL = '',
    } = properties
    subCategoryName = parseMenuCategory(subCategoryName)

    // Fix for CX121-4435
    const subCategoryId = subCategory?.identifier?.toLowerCase() || ''
    // let isToHideCategory =
    //   subCategoryId == 'skin_and_beauty_categories' ||
    //   subCategoryId == 'nutrition_categories' ||
    //   subCategory?.subCategories?.[0]?.isFromOurImpact

    //TD-1090 - above commented changes made configurable in defaultConfig.json
    const hideSeeAllCategoriesList =
      APPConfig?.getAppConfig()?.hideSeeAllCategories || []

    let isToHideCategory =
      hideSeeAllCategoriesList?.includes?.(subCategoryId) ||
      subCategory?.subCategories?.[0]?.isFromOurImpact ||
      false

    // related to CX121-4435
    // pdn fix requested by Kas
    // discussed with Anto/Poovarasan
    const parentCategoryRedirectionMapping =
      APPConfig?.getAppConfig()?.parentCategoryRedirectionMapping || {}

    const shouldRedirectToParentCategoryFromStoreConfig = convertToBoolean(
      APPConfig?.getAppConfig()?.shouldRedirectToParentCategory
    )

    const isToRedirectToCategoryLanding =
      shouldRedirectToParentCategoryFromStoreConfig &&
      Object.keys(parentCategoryRedirectionMapping).some(category => {
        return subCategoryId == category
      })

    const navigateTo = getCategoryLinks(subCategory, false)
    const subCategoryJSX = (className = '') => (
      <div className={`${className} sub-item`}>
        {this.LinkOrA(
          subCategory.identifier,
          <span data-testid="qa-category">{subCategoryName}</span>,
          navigateTo
        )}
      </div>
    )

    const element = document.querySelector('.ourimpact')
    const offsetLeft = element?.getBoundingClientRect?.()?.left || 0
    const ourImpactStyle = {
      position: 'fixed',
      left: offsetLeft,
      width: 'max-content',
    }

    const subCategoryDisplayDom = (
      <span data-testid="qa-category">{subCategoryName}</span>
    )
    return (
      <React.Fragment key={`category_${subCategoryName}`}>
        {subCategories.length === 0 && (
          <>
            {/* {imageURL && (
              <Row className="my-5">
                <Col className="text-right">
                  <Image src={imageURL} height="200px" width="auto"></Image>
                </Col>
                <Col className="text-left">
                  {subCategoryJSX('font-weight-bold')}
                  <span className="nu-menu-subcategory-desc">
                    {meta_description}
                  </span>
                </Col>
              </Row>
            )} */}

            {/* {!imageURL && subCategoryJSX()} */}
            {subCategoryJSX()}
          </>
        )}

        {subCategories.length > 0 && (
          <>
            <div className="font-weight-bold sub-item text-uppercase">
              {/*
               * https://nuskin.atlassian.net/browse/CX32-6916
               * https://nuskin.atlassian.net/browse/CX32-7086
               * for our impacts, isDummyCategory will be true,
               * links should not be clickable
               */}
              {/**
               * TD-1090 - Remove link for Parent category which has See All link from top menu categories
               */}

              {!isToRedirectToCategoryLanding
                ? subCategory?.subCategories?.[0]?.isFromOurImpact
                  ? subCategoryDisplayDom
                  : subCategories.length > 0
                    ? subCategoryDisplayDom
                    : this.LinkOrA(
                        subCategory.identifier,
                        subCategoryDisplayDom,
                        navigateTo
                      )
                : this.LinkOrA(
                    subCategory.identifier,
                    subCategoryDisplayDom,
                    `${pageNames.categoryLanding}/${parentCategoryRedirectionMapping[subCategoryId]}`
                  )}
            </div>

            {subCategory?.identifier === 'ourimpact' && (
              <div style={ourImpactStyle}>
                {subCategories.map(this.renderSubCategoryList)}
              </div>
            )}
            {subCategory.identifier !== 'ourimpact' && (
              <>
                {subCategories.map(this.renderSubCategoryList)}
                {!isToHideCategory &&
                  this.LinkOrA(
                    subCategory.identifier,
                    <span data-testid="qa-category">
                      {i18nTranslate('menu.seeAll', 'See All', {
                        nameSpace: this.nameSpace,
                      })}{' '}
                      {subCategoryName}
                    </span>,
                    navigateTo,
                    'nu-showall-link'
                  )}
              </>
            )}
          </>
        )}
      </React.Fragment>
    )
  }
}

export { SubCategories }
